import './tabFooter.css';

export default class TabFooter {
  container = '.tabFooter';
  trigger = '.tabFooter-title';
  target = '.tabFooter-item';

  constructor() {
    $(this.trigger).on('click', (e) => {
      e.preventDefault();

      // Show current tab content
      const target = $(e.currentTarget).attr('href');
      $(this.target).not(target).removeClass('visible');
      if (DEVICE.isMobile) {
        $(target).toggleClass('visible');
      } else {
        $(target).addClass('visible');
      }

      // Highlight current tab
      const $tabs = $(this.container + ' .tab');
      const $currentTab = $tabs.filter(`[data-tabcode=${target.replace('#', '')}]`);

      $tabs.not($currentTab).removeClass('active');
      $(this.trigger).not(e.currentTarget).removeClass('active');
      if (DEVICE.isMobile) {
        $(e.currentTarget).toggleClass('active');
        $currentTab.toggleClass('active');
      } else {
        $(e.currentTarget).addClass('active');
        $currentTab.addClass('active');
      }
    });
  }
}